// extracted by mini-css-extract-plugin
module.exports = {"topic":"Index_topic__3Tzpv","title":"Index_title__3amcm","content":"Index_content__3BuWN","left":"Index_left__2NuWo","info":"Index_info__2Qvi5","right":"Index_right__2-uR6"};